import PropTypes from "prop-types";
import styles from "./CompanyApproved.module.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../../../../../service/config";
import companyStore from "../../../CompanyStore";
import { useAllProduct } from "../../../../api-context/commonApiContext";

const CompanyApproved = ({ isVisible, onclose, className = "" }) => {
  const { authTokens, isTokenValid, getNewTokens } = useAllProduct();
  const navigate = useNavigate();

  const onApproval = async () => {
    if (!authTokens || Object.keys(authTokens).length === 0) {
      console.log("No auth tokens available, skipping approval.");
      return;
    }

    const obj = {
      kyb_id: companyStore.KYBId,
      status: "approved",
    };

    try {
      // Validate token before API call
      if (!isTokenValid(authTokens.idToken)) {
        console.log("Token invalid or expired, refreshing...");
        await getNewTokens();
        const updatedAuthTokens = JSON.parse(localStorage.getItem("authTokens"));
        if (!updatedAuthTokens?.idToken || !isTokenValid(updatedAuthTokens.idToken)) {
          console.error("Failed to refresh token or new token is invalid.");
          return;
        }
        authTokens.idToken = updatedAuthTokens.idToken; // Update local reference
      }

      // Update KYB status
      await axios.post(`${config.node_api_endpoint}/v1/company/kyb/update_status`, obj, {
        headers: {
          aws_cognito_id_token: authTokens.idToken,
          "Content-Type": "application/json",
        },
      });

      console.log("Request has been approved");
      navigate(`/content/company/route`);
    } catch (err) {
      console.error("Error updating KYB status:", err);
      if (err.response?.data?.error === "Token has expired. Please log in again.") {
        console.log("Token expired during request, refreshing...");
        await getNewTokens();
        const updatedAuthTokens = JSON.parse(localStorage.getItem("authTokens"));
        if (updatedAuthTokens?.idToken && isTokenValid(updatedAuthTokens.idToken)) {
          return onApproval(); // Retry with new token
        }
      }
      // Optionally: Add user feedback (e.g., toast notification)
    } finally {
      onclose(); // Ensure onclose is called in all cases
    }
  };

  if (!isVisible) return null;

  return (
    <div className={`modal show d-block ${styles.approvalModal}`} tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className={`modal-content ${styles.customModalContent}`}>
          <div className={`modal-body ${styles.customModalBody}`}>
            <p>Are you sure you want to approve?</p>
            <img src="/4019677-2131040-1.svg" alt="Approval Icon" className={styles.icon} />
          </div>
          <div className={`modal-footer d-flex justify-content-center`}>
            <button
              type="button"
              style={{ color: "#2348AB", backgroundColor: "#ffffff", border: "1px solid #2348AB" }}
              className={`btn btn-secondary ${styles.customCancelBtn}`}
              onClick={onclose}
            >
              No
            </button>
            <button
              type="button"
              style={{ backgroundColor: "#2348AB", border: "1px solid #2348AB" }}
              className={`btn btn-primary ${styles.customApproveBtn}`}
              onClick={onApproval}
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

CompanyApproved.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onclose: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default CompanyApproved;
